export default __webpack_public_path__ + "static/cocoon-c4bb6c0d991872e2671f932e8aad4581.mp4";